import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=f115ae2c&lang=pug&"
import script from "./SuccessModal.vue?vue&type=script&lang=js&"
export * from "./SuccessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports